import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorIntlSv extends MatPaginatorIntl {
  constructor(private readonly translate: TranslateService) {
    super();
  }

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = this.translate.instant('paginator.items_per_page_label');
    paginatorIntl.nextPageLabel = this.translate.instant('paginator.next_page_label');
    paginatorIntl.previousPageLabel = this.translate.instant('paginator.previous_page_label');
    paginatorIntl.firstPageLabel = this.translate.instant('paginator.first_page_label');
    paginatorIntl.lastPageLabel = this.translate.instant('paginator.last_page_label');
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    return paginatorIntl;
  }

  getRangeLabel = function(page, pageSize, length) {
    if (length === 0 || pageSize === 0) {
      return '0 av ' + length;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' av ' + length;
  };
}
